import { Home } from "lucide-react";

const norm = (s) => (s || "").trim();

export default function RoomCostsSection({ purchases }) {
  const items = purchases || [];

  const clientPriceOf = (p) =>
    p.client_price != null ? p.client_price : (p.quantity || 0) * (p.trade_cost || 0) * (1 + (p.markup || 0) / 100);

  const byRoom = items.reduce((acc, p) => {
    const room = norm(p.room) || "Unassigned";
    acc[room] = (acc[room] || 0) + clientPriceOf(p);
    return acc;
  }, {});
  const rooms = Object.keys(byRoom).sort((a, b) =>
    a === "Unassigned" ? 1 : b === "Unassigned" ? -1 : a.localeCompare(b));
  const total = items.reduce((s, p) => s + clientPriceOf(p), 0);
  const fmt = (n) => `$${(n || 0).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;

  return (
    <div className="max-w-4xl space-y-6 pt-10 mt-10 border-t border-[#EBE5E0]" data-testid="room-costs-section">
      <div className="flex items-end justify-between">
        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-[#A68A6B] mb-1">By Room</p>
          <h3 className="font-serif text-3xl text-[#2B2622]">Costs per Room</h3>
          <p className="text-sm text-[#5C5651] mt-1">Running total of itemized purchases, grouped by the room set on each purchase.</p>
        </div>
        <div className="text-right">
          <p className="text-[11px] uppercase tracking-wider text-[#A68A6B]">Total</p>
          <p data-testid="room-costs-total" className="font-serif text-3xl text-[#2B2622]">{fmt(total)}</p>
        </div>
      </div>

      {rooms.length === 0 ? (
        <div className="border border-dashed border-[#D9CBBF] bg-white p-10 text-center text-[#5C5651]">
          No purchases with a room yet. Add a room when recording a purchase to see the breakdown here.
        </div>
      ) : (
        <div className="border border-[#EBE5E0] bg-white">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-[#EBE5E0] text-left text-[11px] uppercase tracking-wider text-[#A68A6B]">
                <th className="p-4 font-medium">Room</th>
                <th className="p-4 font-medium text-right">Spent</th>
                <th className="p-4 font-medium text-right w-24">Share</th>
              </tr>
            </thead>
            <tbody>
              {rooms.map((room) => {
                const amt = byRoom[room];
                const pct = total ? Math.round((amt / total) * 100) : 0;
                return (
                  <tr key={room} className="border-b border-[#F2EFEB] last:border-0" data-testid={`room-cost-row-${room}`}>
                    <td className="p-4 text-[#2B2622]">
                      <span className="inline-flex items-center gap-2">
                        <Home size={14} strokeWidth={1.5} className="text-[#A68A6B]" />
                        {room}
                      </span>
                    </td>
                    <td className="p-4 text-right text-[#2B2622] font-medium">{fmt(amt)}</td>
                    <td className="p-4 text-right text-[#5C5651]">{pct}%</td>
                  </tr>
                );
              })}
              <tr className="bg-[#F9F8F6] font-medium" data-testid="room-costs-totals">
                <td className="p-4 text-[#2B2622] uppercase text-xs tracking-wider">Total</td>
                <td className="p-4 text-right text-[#2B2622]">{fmt(total)}</td>
                <td className="p-4 text-right text-[#2B2622]">100%</td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
